import { dispatchCredentialLogout, handleCredentialError } from "./authGuard";

/**
 * Wrapper de fetch que detecta errores JWT (401/403) y dispara un evento global
 * para que App.js haga logout automáticamente.
 */
export default async function fetchWithAuth(url, options) {
  const response = await fetch(url, options)

  if (response.status === 401 || response.status === 403) {
    dispatchCredentialLogout({ status: response.status, source: "http-status" })
    throw new Error("JWT_ERROR")
  }

  const isClientCredentialCandidate =
    response.status >= 400 && response.status < 500 && response.status !== 404

  if (!response.ok && isClientCredentialCandidate) {
    try {
      const errorText = await response.clone().text()
      if (handleCredentialError(errorText)) {
        throw new Error("JWT_ERROR")
      }
    } catch (error) {
      if (error.message === "JWT_ERROR") {
        throw error
      }
    }
  }

  return response
}
